<template>
    <div ref="search" class="mt-lg">
        <SearchBox />

        <div class="filters">
            <RefinementDropdown attribute="state" label="State" :options="$root.states" />
            <RefinementDropdown attribute="technologyType" label="Technology Type" :options="$root.technologyTypes" />
            <RefinementDropdown attribute="employmentType" label="Employment type" :options="['Full Time', 'Part Time', 'Casual', 'Contract', 'Temporary', 'Job Share']" />
            <RefinementDropdown attribute="seniorityLevel" label="Seniority level" :options="['Entry Level', 'Junior', 'Mid-Level', 'Senior', 'Executive']" />
        </div>

        <div v-if="loading" class="text--center">
            <img src="/dist/images/loader.gif" alt="Loading...">
        </div>

        <template v-else-if="results && results.value.length">
            <template v-for="(post, index) in sortedResults">
                <Post :key="index" :post="post" />

                <a v-if="index === 0 && $root.adLink && $root.desktopAd && $root.mobileAd" :key="'ad' + index" class="ad-space" :href="$root.adLink" target="_blank">
                    <img v-if="$resize && $mq.above(767) && $root.desktopAd" :src="$root.desktopAd" />
                    <img v-else-if="$root.mobileAd" :src="$root.mobileAd" />
                </a>
            </template>

            <Pagination :subset.sync="paginatedResults" :set="results.value" :items-per-page="5" @page-change="scrollTop" />
        </template>

        <p v-else class="my-xl text--center">
            No results found.
        </p>
    </div>
</template>

<script>
import axios from 'axios';
import { init } from '../searchy';
import SearchBox from './components/SearchBox.vue';
import RefinementDropdown from './components/RefinementDropdown.vue';
import Pagination from './components/Pagination.vue';
import Post from './components/Post.vue';
// import dummyData from './data.json';

export default {
    components: {
        RefinementDropdown,
        SearchBox,
        Pagination,
        Post
    },

    data() {
        return {
            loading: true,
            results: null,
            paginatedResults: [],
        };
    },

    computed: {
        sortedResults() {
            return [...this.paginatedResults].sort( (a,b) => b.featured - a.featured );
        }
    },

    async created() {
        const { data } = await axios.get('/api/careers.json');

        this.results = await init({
            dataset: data.data
        });

        this.loading = false;
    },

    methods: {
        scrollTop() {
            const el = document.querySelector('#careers-wrapper');
            el.scrollIntoView();
        }
    }
};
</script>

<style lang="scss" scoped>
    .filters {
        display: flex;
        margin: 1.5em 0;
        padding-bottom: 2em;
        border-bottom: 1px solid #DDDDDD;

        @media screen and (min-width:769px) and (max-width:960px) {
            flex-wrap: wrap;
            margin-left: -1%;
            margin-right: -1%;
        }

        @media screen and (max-width:768px) {
            flex-direction: column;
        }

        > div {
            flex: 1;
            margin-left: 2em;

            @media screen and (min-width:769px) and (max-width:960px) {
                flex: 0 0 48%;
                margin: 1% !important;
            }

            @media screen and (max-width:768px) {
                margin-left: 0;
                margin-bottom: 1em;
            }

            &:first-child {
                margin-left: 0;
            }
        }
    }

    .ad-space {
        display: block;
        margin: 0 auto 2em;
    }
</style>